const SEEN_KEY_PREFIX = 'robinhoot_wrap_seen_';

/** Whether this browser has opened that year's story or dismissed its banner. */
export function hasSeenWrap(year: number): boolean {
  try {
    return localStorage.getItem(`${SEEN_KEY_PREFIX}${year}`) !== null;
  } catch {
    return false;
  }
}

export function markWrapSeen(year: number): void {
  try {
    localStorage.setItem(`${SEEN_KEY_PREFIX}${year}`, String(Date.now()));
  } catch {
    // localStorage unavailable
  }
}
